import React, { createContext, useState, useContext } from 'react';

const SpinnerContext = createContext();

export const SpinnerProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  return (
    <SpinnerContext.Provider value={{ loading, setLoading }}>
      {children}
      {loading && (
        <div style={spinnerOverlayStyle}>
          <div className="loader" />
        </div>
      )}
    </SpinnerContext.Provider>
  );
};

export const useSpinner = () => useContext(SpinnerContext);

const spinnerOverlayStyle = {
  position: 'fixed',
  top: 0, left: 0, width: '100%', height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  zIndex: 9999,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

